import styled from "styled-components";

type Open = {
  isOpen: boolean;
};

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 99999;
`;
export const Dropdown = styled.div<Open>`
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 99999;
  gap: 0.1rem;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 2px;
  padding: 0.5rem;
  min-width: 200px;
  top: 200%;
  right: 4px;
  body[dir="rtl"] & {
    left: 4px;
    right: unset;
  }
  opacity: ${(props: { isOpen: boolean }) => (props.isOpen ? "1" : "0")};
  transition: opacity 0.3s ease-in-out;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  pointer-events: ${(props: { isOpen: boolean }) =>
    props.isOpen ? "all" : "none"};
`;
export const Item = styled.button`
  background-color: transparent;
  width: 100%;
  padding: 0.5rem;
  transition: background 0.2s ease-in-out;
  font-size: 14px;
  &:hover {
    background-color: ${({ theme: { colors } }) => colors.gray200};
  }
`;
